import { useState } from 'react';
import SubHeader from '@/pages/profile/components/SubHeader';
import { useToast } from '@/components/base/Toast';
import { helpFaqs } from '@/mocks/profile';

export default function HelpPage() {
  const { showToast } = useToast();
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <div className="min-h-screen bg-brown-50 pb-20">
      <SubHeader title="帮助中心" />

      {/* Contact */}
      <div className="px-4 mt-4">
        <div className="bg-gradient-to-r from-brown-900 to-brown-800 rounded-2xl p-5 flex items-center justify-between">
          <div>
            <p className="text-gold-300 text-xs mb-1">需要人工协助？</p>
            <p className="text-white text-base font-semibold">在线客服 7×24 小时</p>
          </div>
          <button
            onClick={() => showToast('客服已接入，请稍候', 'info')}
            className="bg-gold-500 text-brown-950 px-5 py-2.5 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap active:scale-95 transition-transform"
          >
            联系客服
          </button>
        </div>
      </div>

      {/* FAQ */}
      <div className="px-4 mt-4">
        <h3 className="text-brown-900 text-sm font-bold mb-3">常见问题</h3>
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm">
          {helpFaqs.map((faq, idx) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className={idx !== helpFaqs.length - 1 ? 'border-b border-brown-50' : ''}
              >
                <button
                  onClick={() => setOpenId(isOpen ? null : faq.id)}
                  className="w-full flex items-center justify-between px-4 py-4 text-left cursor-pointer"
                >
                  <span className="text-brown-900 text-sm font-medium flex-1 pr-3">{faq.q}</span>
                  <span
                    className={`w-5 h-5 flex items-center justify-center text-gold-600 transition-transform duration-300 flex-shrink-0 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-60' : 'max-h-0'
                  }`}
                >
                  <p className="px-4 pb-4 text-brown-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Other Contact */}
      <div className="px-4 mt-4 grid grid-cols-2 gap-3">
        {[
          { icon: 'ri-phone-line', label: '客服热线', value: '400-888-8888' },
          { icon: 'ri-mail-line', label: '官方邮箱', value: 'service@jinan.cn' },
        ].map((item) => (
          <div key={item.label} className="bg-white rounded-2xl p-4 shadow-sm text-center">
            <div className="w-10 h-10 rounded-full bg-gold-50 flex items-center justify-center mx-auto mb-2">
              <span className="w-5 h-5 flex items-center justify-center text-gold-600">
                <i className={`${item.icon} text-lg`}></i>
              </span>
            </div>
            <p className="text-brown-500 text-xs">{item.label}</p>
            <p className="text-brown-900 text-sm font-semibold mt-1">{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}